import FulfillmentService from '@/api/fulfillment.service';

const state = () => ({
  warehouseFulfillments: { data: [] },
  backOrderFulfillments: { data: [] },
});

const getters = {
  GetWarehouseFulfillments: (state) => state.warehouseFulfillments,
  GetBackOrderFulfillments: (state) => state.backOrderFulfillments,
};

const mutations = {
  SET_WAREHOUSE_FULFILLMENTS: (state, payload) => {
    state.warehouseFulfillments = payload;
  },
  SET_BACKORDER_FULFILLMENTS: (state, payload) => {
    state.backOrderFulfillments = payload;
  },
};

const actions = {
  CreateFulfillments: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.create(authToken, payload);
      // console.log("fetchDistros", response);
      return response;
    } catch (error) {
      return error;
    }
  },
  CreateBackOrderFulfillments: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.backOrderFulfillment(
        authToken,
        payload
      );
      // console.log("fetchDistros", response);
      return response;
    } catch (error) {
      return error;
    }
  },
  FetchBackOrderFulfillments: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.backOrderFulfillments(
        authToken,
        payload
      );
      // console.log("fetchDistros", response);
      context.commit('SET_BACKORDER_FULFILLMENTS', response.data);
    } catch (error) {
      return error;
    }
  },
  ChangeFulfillmentStatus: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.status(authToken, payload);
      // console.log("fetchDistros", response);
      return response;
    } catch (error) {
      return error;
    }
  },
  ChangeBackOrderFulfillmentStatus: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.backOrderStatus(
        authToken,
        payload
      );
      // console.log("fetchDistros", response);
      return response;
    } catch (error) {
      return error;
    }
  },
  FetchWarehouseFulfillments: async (context, payload) => {
    const { authToken } = context.rootState.auth;
    try {
      const response = await FulfillmentService.fulfillments(
        authToken,
        payload
      );
      // console.log("fetchDistros", response);
      context.commit('SET_WAREHOUSE_FULFILLMENTS', response.data);
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
